// lib files
import { VideoClass } from '@/lib/types/api/video';

// components
import MyListVideoGridItem from '@/components/MyList/MyListVideos/MyListVideoGridItem';

// styles
import styles from './MyListVideosGrid.module.scss';

interface MyListVideosGridProps {
  videos: VideoClass[];
}

const MyListVideosGrid = (props: MyListVideosGridProps) => {
  const { videos } = props;

  return (
    <div className={styles.my_list_videos_grid}>
      {videos.map((video, i: number) => {
        return (
          <MyListVideoGridItem video={video} key={i} />
        )
      })}
    </div>
  );
};

export default MyListVideosGrid;
